import React from 'react';
import { connect } from 'react-redux';
import ByLocOptions from './filters/ByLocOptions';
import ByEquipOptions from './filters/ByEquipOptions';

import './FilterSection.css';

const FilterSection = ({ resultsViewType }) => (
  <div className="FilterSectionView">
    {(resultsViewType === 'EquipType' || resultsViewType === 'Equip') && (
      <div>
        <ByLocOptions />
      </div>
    )}
    {resultsViewType === 'Equip' && (
      <div>
        <ByEquipOptions />
      </div>
    )}
  </div>
);

export default connect(({ ui: { resultsViewType } }) => ({
  resultsViewType,
}))(FilterSection);
